import Image, { StaticImageData } from "next/image";
import { Dispatch, SetStateAction } from "react";
import TabsTrigger from "@/components/ui/Tabs/TabsTrigger";
import { PartName, SelectingPart } from "@/types/design";
import BackHairIcon from "@public/backHairMenuIcon.svg";
import EyebrowsIcon from "@public/eyebrowsMenuIcon.svg";
import EyesIcon from "@public/eyesMenuIcon.svg";
import HairIcon from "@public/hairMenuIcon.svg";
import MouthIcon from "@public/mouthMenuIcon.svg";
import EyelineIcon from "@public/eyelineMenuIcon.svg";

import usePartMenu from "./PartMenu.hook";
import styles from "./PartMenu.module.scss";

type Props = {
	setShowPalette: Dispatch<SetStateAction<boolean>>;
	setShowPartMove: Dispatch<SetStateAction<boolean>>;
};

type PartMenuItems = {
	name: PartName;
	icon: StaticImageData;
	alt: string;
};

export const partMenuItems: PartMenuItems[] = [
	{ name: "hair", icon: HairIcon, alt: "髪の毛パーツの一覧を表示します" },
	{
		name: "backHair",
		icon: BackHairIcon,
		alt: "後ろ髪毛パーツの一覧を表示します",
	},
	{
		name: "eyebrows",
		icon: EyebrowsIcon,
		alt: "眉毛パーツの一覧を表示します",
	},
	{
		name: "eyeline",
		icon: EyelineIcon,
		alt: "アイラインパーツの一覧を表示します",
	},
	{ name: "eyes", icon: EyesIcon, alt: "目パーツの一覧を表示します" },
	{ name: "mouth", icon: MouthIcon, alt: "口パーツの一覧を表示します" },
];

/**
 * パーツメニュー コンポーネント
 * @returns {JSX.Element} パーツメニュー コンポーネント
 */
export default function PartMenu(props: Props) {
	const { setShowPalette, setShowPartMove } = props;
	const { onPartMenuClick } = usePartMenu({
		setShowPalette,
		setShowPartMove,
	});

	return (
		<div className={styles.partsMenuContainer}>
			{partMenuItems.map((item: any) => (
				<TabsTrigger
					key={item.name}
					value={item.name}
					onClick={() => onPartMenuClick(item.name)}
				>
					<div className={styles.partMenuIcon}>
						<Image
							src={item.icon}
							alt={item.alt}
							className={styles.icon}
						/>
					</div>
				</TabsTrigger>
			))}
		</div>
	);
}
